import { useCallback } from "react";
import { useI18n } from "./i18n-hooks";

export const useValidateFieldMinMax = () => {
    const i18n = useI18n();

    const validateFieldMinMax = useCallback(
        ({ value, min, max }: { value?: number | null; min?: number; max?: number }) => {
            if (!value) {
                return true;
            }
            if (max !== undefined && value > max) {
                return i18n.t("errors.numberMax", { max });
            } else if (min !== undefined && value < min) {
                return i18n.t("errors.numberMin", { min });
            }
            return true;
        },
        [i18n],
    );

    return validateFieldMinMax;
};
